import ActiveOrder from "@/models/activeOrder/ActiveOrder";

export const SET_ACTIVE_ORDERS = 'setActiveOrders';

export const mutations = {
  setActiveOrders(state, data) {
    state.activeOrders = data.map(item => ActiveOrder.create(item));
  },
}
